import { render, staticRenderFns } from "./PeiZai.vue?vue&type=template&id=3f11a91c&scoped=true&"
import script from "./PeiZai.vue?vue&type=script&lang=js&"
export * from "./PeiZai.vue?vue&type=script&lang=js&"
import style0 from "./PeiZai.vue?vue&type=style&index=0&id=3f11a91c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f11a91c",
  null
  
)

export default component.exports